import { Flex, Text } from "@fluentui/react-northstar";
import { Card } from "antd";
import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import ReactApexChart from "react-apexcharts";

const GradeDistribution = ({
  distribution = {
    averageGrade: "B+",
    trend: {
      value: 2.1,
      direction: "up",
    },
    distribution: [
      { grade: "A", percentage: 80 },
      { grade: "B", percentage: 100 },
      { grade: "C", percentage: 60 },
      { grade: "D", percentage: 40 },
      { grade: "F", percentage: 25 },
    ],
  },
}) => {
  return (
    <Card style={{ height: "100%" }} className="shadow">
      <Flex fill space="between">
        <Text content="Grading Distribution" />
        {distribution.trend.value > 0 && (
          <Text
            style={{
              color:
                distribution.trend.direction === "up" ? "#10B981" : "#EF4444",
              fontWeight: 500,
            }}
          >
            {distribution.trend.direction === "up" ? (
              <ArrowUpOutlined />
            ) : (
              <ArrowDownOutlined />
            )}
            {distribution.trend.value}%
          </Text>
        )}
      </Flex>
      <div style={{ margin: "16px 0 8px 0", borderRadius: "8px" }}>
        <Text size="larger" weight="bold" content={distribution.averageGrade} />
      </div>
      <div style={{ height: 120 }}>
        <ReactApexChart
          type="bar"
          height={100}
          options={{
            chart: { toolbar: { show: false }, sparkline: { enabled: true } },
            plotOptions: {
              bar: {
                borderRadius: 4,
                columnWidth: '40%',
                distributed: true,
              },
            },
            dataLabels: { enabled: false },
            xaxis: {
              categories: distribution.distribution.map((item) => item.grade),
              labels: { style: { fontSize: '12px' } },
            },
            yaxis: { show: false },
            grid: { show: false },
            colors: [
              '#10B981', // A  
              '#A3E635', // B  
              '#FDE047', // C  
              '#FDBA74', // D  
              '#FCA5A5', // F  
            ],
            tooltip: {
              y: {
                formatter: (val) => `${val}%`,
              },
            },
          }}
          series={[{
            data: distribution.distribution.map((item) => item.percentage),
          }]}
        />
      </div>
    </Card>
  );
};

export default GradeDistribution;
